"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNetworkStatus = useNetworkStatus;
var react_1 = require("react");
/**
 * Get up-to-date network status
 *
 * @returns status information in two flags
 */
function useNetworkStatus() {
    var _a = (0, react_1.useState)(window.navigator.onLine), isOnline = _a[0], setIsOnline = _a[1];
    (0, react_1.useEffect)(function () {
        var updateNetwork = function () { return setIsOnline(window.navigator.onLine); };
        window.addEventListener('online', updateNetwork);
        window.addEventListener('offline', updateNetwork);
        return function () {
            window.removeEventListener('online', updateNetwork);
            window.removeEventListener('offline', updateNetwork);
        };
    });
    return (0, react_1.useMemo)(function () { return ({ isOnline: isOnline, isOffline: !isOnline }); }, [isOnline]);
}
//# sourceMappingURL=use_network_status.js.map